/** @jsx isolateComponent */
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableRow` component.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('TableHead', {
  root: css`
    display: table-header-group;
  `,
});

/**
 * The `thead` tag; use to describe column data.
 */
export const TableHead = (props: Props) => {
  return <thead css={Styles.root}>{props.children}</thead>;
};
